import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addLayoverDuration'
})
export class AddLayoverDurationPipe implements PipeTransform {

  // transform(item: any): number {
  //   if (!item) return 0;

  //   let totalDuration = item.totaljourneyduration || 0;

  //   // Sum layover times in seconds, then convert to minutes
  //   if (Array.isArray(item.layovers)) {
  //     const layoverMinutes = item.layovers.reduce((sum, layoverObj) => {
  //       const value = Object.values(layoverObj)[0] as number; // in seconds
  //       return sum + Math.floor(value / 60); // convert to minutes
  //     }, 0);
  //     totalDuration += layoverMinutes;
  //   }

  //   return totalDuration;
  // }

  transform(item: {
    totaljourneyduration?: number;
    layovers?: Array<Record<string, number>>;
  }): number {
    if (!item || typeof item.totaljourneyduration !== 'number') return 0;

    const totalLayoverMinutes = (item.layovers ?? []).reduce((sum, layoverObj) => {
      return sum + Object.values(layoverObj).reduce((innerSum, seconds) => {
        const sec = Number(seconds);
        return innerSum + (isNaN(sec) ? 0 : Math.floor(sec / 60));
      }, 0);
    }, 0);

    return item.totaljourneyduration + totalLayoverMinutes;
  }

}
